/**
 * Model definition for skp-calculator
 */

export interface FormsSkpCalculator {
  __component: 'forms.skp-calculator';
  id: string;
  initialPeriod: number;
  initialLoan: number;
  creditTerm: 'normal' | 'special' | 'plus';
  productButtonsDefault: 'free' | 'car';
  productButtonsShouldShow: 'true' | 'false';
}

export function isFormsSkpCalculator(obj: { __component?: string }): obj is FormsSkpCalculator {
  return obj.__component === 'forms.skp-calculator';
}
